/* eslint-disable react/sort-comp */
/* eslint-disable array-callback-return */
/* eslint-disable */
import React, { Component } from 'react';
import {
  Tabs,
  Tab,
  TabsSkeleton,
  Button,
  AccordionItem,
  Accordion,
  SkeletonText,
  Loading,
  InlineLoading,
  Tile,
  FormGroup,
  DatePicker,
  DatePickerInput,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TextArea,
  InlineNotification,
  Toggle,
  ComposedModal,
  ModalBody,  
  ModalHeader,
  Checkbox  
} from 'carbon-components-react';
import { Information16, CheckmarkOutline16, Send16, Error16, Download16 } from '@carbon/icons-react';
import View16 from '@carbon/icons-react/lib/view/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Attachment16 from '@carbon/icons-react/lib/attachment/16';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import Add16 from '@carbon/icons-react/lib/add/16';
import { Link } from 'react-router-dom';

import moment from 'moment';

import SimpleReactValidator from 'simple-react-validator';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEnabled, IsEditable, CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { api, audit, me } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  sizeFormat,
  getSuccess,
  apioperation,
  entitiesLabels,
  STATUS,
} from '../../helpers/Constants';
import CheckListQuestionAnswer from './common/CheckListQuestionAnswer';
import FileUpload from '../common/FileUpload';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import CheckListRequirement from './common/CheckListRequirement';
import AuditPersonnel from './common/AuditPersonnel';
import AuditNotificationForm from './common/AuditNotificationForm';
import PageBreadCrumb, { StatusTag } from '../../helpers/PageBreadCrumb';
import { WFActionModal } from '../common/WFActionModal';
import { HistoryTable } from '../../helpers/HistoryTable';
import AuditRepository from '../../helpers/api/AuditRepository';
import { Online, Offline } from '../common/OnLineOffLine';
import DownLoadButton from '../common/FileDownloadButton';

export default class AuditReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabsLoading: true,
      audit: {},
      requirementToDelete: null,
      isSubmitted: false,
      mainInformationOpened: false,
      downloading: null,
      modalAddRequirementVisible: false,
      addRequirementTemplate: null,
      addRequirementSection: null,
      modalDeleteRequirementVisible: false,
      modalUpdateRequirementVisible: false,
      modalDeleteAttachmentVisible: false,
      modalDeleteReportAttachmentVisible: false, //RITM0646764
      checkListRequirementToModify: null,
      requirementToModify: null,
      employees: [],
      selectedAttachment: null,
      editingDisabled: true,
      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      approverWarning: null, //RITM0646764
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      // /Status Action
      isHistoryModalOpen: false,
      // //
      validationSend: true,
      validationAnswer: false,
      //userDivision: [], //B1_Audit_Module_Optimization

      //DEV 550
      checklistTemplates: [],
      isLoadingNotificationFile: false,
      activitiesData: [],
    };

    this.getItems = this.getItems.bind(this);
    this.getTemplate = this.getTemplate.bind(this);
    this.getSections = this.getSections.bind(this);
    this.getQuestionAnswer = this.getQuestionAnswer.bind(this);
    this.getRequirementAnswer = this.getRequirementAnswer.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.onAnswerChange = this.onAnswerChange.bind(this);
    this.onNoteChange = this.onNoteChange.bind(this);
    this.updateCheckList = this.updateCheckList.bind(this);
    this.updatePersonnel = this.updatePersonnel.bind(this);
    this.updateConsideration = this.updateConsideration.bind(this);
    this.updateMainInformation = this.updateMainInformation.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.onMainInformationAccordionClick = this.onMainInformationAccordionClick.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onAdditionalNoteChange = this.onAdditionalNoteChange.bind(this);
    this.onReportSummaryChange = this.onReportSummaryChange.bind(this);
    this.onIntroductionChange = this.onIntroductionChange.bind(this);
    this.onUpload = this.onUpload.bind(this);

    this.onDeleteAttachment = this.onDeleteAttachment.bind(this);
    this.showAddRequirement = this.showAddRequirement.bind(this);
    this.showModifyRequirement = this.showModifyRequirement.bind(this);
    this.showDeleteRequirement = this.showDeleteRequirement.bind(this);
    this.newCheckListRequirementAdded = this.newCheckListRequirementAdded.bind(this);
    this.checkListRequirementUpdated = this.checkListRequirementUpdated.bind(this);
    this.handleRequirementDelete = this.handleRequirementDelete.bind(this);
    this.handleDeleteAttachmentModalVisibility = this.handleDeleteAttachmentModalVisibility.bind(
      this
    );
    this.handleRequirementDeleteCancel = this.handleRequirementDeleteCancel.bind(this);
    this.onAuditorAdd = this.onAuditorAdd.bind(this);
    this.onAuditorDelete = this.onAuditorDelete.bind(this);
    this.getEmployees = this.getEmployees.bind(this);
    this.onAuditeesAdd = this.onAuditeesAdd.bind(this);
    this.onAuditeesDelete = this.onAuditeesDelete.bind(this);
    this.updateNotificationData = this.updateNotificationData.bind(this);
    this.sendNotificationData = this.sendNotificationData.bind(this);
    this.CanUserEdit = this.CanUserEdit.bind(this);
    this.CanAuditorEdit = this.CanAuditorEdit.bind(this);
    this.repository = new AuditRepository();
    this.validator = new SimpleReactValidator();
    this.validationsAnswer = new SimpleReactValidator();
  }

  async componentDidMount() {
    this.setState({ tabsLoading: true });
    const audit = await this.getItems();
    //const userDivision = await this.repository.getAuditors(); //B1_Audit_Module_Optimization
    this.setState({
      audit,
      //userDivision, //B1_Audit_Module_Optimization
      tabsLoading: false,
      editingDisabled: !this.CanUserEdit(audit),
    });
    // this.getEmployees();
    this.validationSendNotification();
  }

  CanUserEdit = (audit) => {
    return (
      IsEditable(
        'Audit',
        this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
        this.context.user,
        audit?.checkList?.status?.id,
        'All',
        audit?.checkList
      ) || this.CanAuditorEdit(audit)
    );
  };

  CanAuditorEdit = (audit) => {
    var canEdit = false;
    audit?.auditors.forEach((auditor) => {
      canEdit =
        canEdit ||
        IsEditable(
          'Audit',
          this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
          this.context.user,
          audit?.checkList?.status?.id,
          'All',
          auditor
        );
    });
    return canEdit;
  };

  showButtonHistory = () => (
    <Button
      className="action-button-modal"
      kind="secondary"
      renderIcon={Information16}
      onClick={() => this.openModalHistory()}
    >
      History
    </Button>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  onAnswerChange = (id, answer) => {
    const { answers } = this.state.audit.checkList;
    const index = answers.findIndex((qa) => qa.id === id);
    if (answers[index].answer !== answer) answers[index].answer = answer;
    else answers[index].answer = null;
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.checkList.answers = answers;
      return { audit };
    });
  };

  onMainInformationAccordionClick(obj) {
    this.setState({ mainInformationOpened: obj.isOpen });
  }

  onNoteChange(id, note) {
    note.preventDefault();
    const { answers } = this.state.audit.checkList;
    const index = answers.findIndex((qa) => qa.id === id);
    answers[index].notes = note.target.value;
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.checkList.answers = answers;
      return { audit };
    });
  }

  onAuditRemoteChange = (e) => {
		const val = e;
		this.setState((prevState) => {
			const audit = { ...prevState.audit };
			audit.auditRemote = val;
			return { audit };
		});
	};

  onStartDateChange(e) {
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      // audit.startDate = switchDateFormat(startDate[0], 'yyyyMMdd');
      audit.startDate = moment(e[0]).format('YYYY-MM-DD');
      audit.endDate = moment(e[1]).format('YYYY-MM-DD');
      return { audit };
    });
  }

  onEndDateChange(endDate) {
    this.setState((prevState) => {
      const audit = { ...prevState.audit };

      audit.endDate = switchDateFormat(endDate[0], 'yyyyMMdd');
      return { audit };
    });
  }

  onReportSummaryChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.reportSummary = value;
      return { audit };
    });
  }

  onIntroductionChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.introduction = value;
      return { audit };
    });
  }

  onAdditionalNoteChange(event) {
    const { value } = event.currentTarget;
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.additionalNotes = value;
      return { audit };
    });
  }

  onAuditorAdd(item) {
    if (item.id == null) {
      item.id = uuid();
    }
    const emailduplicate = this.state.audit.auditors.filter((el) => el.id == item.id);
    const emailduplicateNoSaipem = this.state.audit.auditorsNoSaipem.filter(
      (el) => el.email == item.email
    );
    if (emailduplicate == 0 && emailduplicateNoSaipem == 0) {
      this.setState((prevState) => {
        const audit = { ...prevState.audit };
        item.fullName = `${item.name} ${item.surname}`;
        item.role = 'Auditor';
        if (item.idEmployer != null) {
          audit.auditors = prevState.audit.auditors.concat(item);
        } else {
          audit.auditorsNoSaipem = prevState.audit.auditorsNoSaipem.concat(item);
          item.external = true;
          audit.auditors = prevState.audit.auditors.concat(item);
        }
        return { audit };
      });
    } else {
      showNotification.warning(`${entitiesLabels.WARNING}`, ' Auditors duplicate email ');
    }
  }

  onAuditeesAdd(item) {
    if (item.id == null) {
      item.id = uuid();
    }
    const emailduplicate = this.state.audit.auditees.filter((el) => el.id == item.id);
    const emailduplicateNoSaipem = this.state.audit.auditeeNoSaipem.filter(
      (el) => el.email == item.email
    );
    if (emailduplicate == 0 && emailduplicateNoSaipem == 0) {
      this.setState((prevState) => {
        const audit = { ...prevState.audit };
        item.fullName = `${item.name} ${item.surname}`;

        if (item.idEmployer != null) {
          audit.auditees = prevState.audit.auditees.concat(item);
        } else {
          audit.auditeeNoSaipem = prevState.audit.auditeeNoSaipem.concat(item);
          item.external = true;
          item.role = 'Auditee';
          audit.auditees = prevState.audit.auditees.concat(item);
        }

        return { audit };
      });
    } else {
      showNotification.warning(`Warning: ${entitiesLabels.AUDIT} Auditors duplicate email `);
    }
  }

  onAuditorDelete(item) {
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.auditors = prevState.audit.auditors.filter((a) => a.id !== item.id);
      audit.auditorsNoSaipem = prevState.audit.auditorsNoSaipem.filter(
        (a) => a.email !== item.email
      );
      return { audit };
    });
  }

  onAuditeesDelete(item) {
    this.setState((prevState) => {
      const audit = { ...prevState.audit };
      audit.auditees = prevState.audit.auditees.filter((a) => a.id !== item.id);
      audit.auditeeNoSaipem = prevState.audit.auditeeNoSaipem.filter((a) => a.email !== item.email);
      return { audit };
    });
  }

  async onUpload(fileIdentifier, fileName, fileType, size) {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    try {
      this.setState({ isSubmitted: true });
      await api.post(`/audit/${this.state.audit.id}/attachment`, newAttach);
      return this.setState((prevState) => {
        const audit = { ...prevState.audit };
        audit.attachments.push(newAttach);
        return { audit };
      });
    } catch (error) {
      return showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.AUDIT, apioperation.POST)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  onDeleteAttachment(Id) {
    const selectedItem = this.state.audit.attachments.find((item) => item.id === Id);
    this.setState((oldState) => ({
      selectedAttachment: selectedItem,
      modalDeleteAttachmentVisible: !oldState.modalDeleteAttachmentVisible,
    }));
  }
 
  //#region AuditReportAttachment RITM0646764
  onUploadReportSigned = async (fileIdentifier, fileName, fileType, size) => {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    try {
      this.setState({ isSubmitted: true });
      await api.post(`/audit/${this.state.audit.id}/auditreportattachment`, newAttach);
      return this.setState((prevState) => {
        const audit = { ...prevState.audit };
        const selectedAttachment = {
          idAudit: audit.id,
          idAttachment: newAttach.id,
          attachment: newAttach
        }
        audit.reportAttachments.push(selectedAttachment);
        return { audit };
      });
    } catch (error) {
      return showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.AUDIT, apioperation.POST)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  }

  onDeleteAttachmentReportSigned = (Id) => {
    const selectedItem = this.state.audit.reportAttachments.find((item) => item.attachment.id === Id);
    var selectedAttachment = null;
    if(selectedItem){
      selectedAttachment = selectedItem.attachment;
    }
    this.setState((oldState) => ({
      selectedAttachment: selectedAttachment,
      modalDeleteReportAttachmentVisible: !oldState.modalDeleteReportAttachmentVisible,
    }));
  }

  deleteReportAttachment = async () => {
    try {
        this.setState({ isSubmitted: true });
        await api.deleteData(
            `/audit/${this.state.audit.id}/auditreportattachment/${this.state.selectedAttachment.fileIdentifier}`
        );
        this.setState((prevState) => {
            const audit = { ...prevState.audit };
            audit.reportAttachments = prevState.audit.reportAttachments.filter(
                (a) => a.attachment.id !== prevState.selectedAttachment.id
            );
            return { audit };
        });
        return this.handleDeleteReportAttachmentModalVisibility();
    } catch (error) {
        return showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.FileUpload, apioperation.DELETE)
        );
    } finally {
        this.setState({ isSubmitted: false });
    }
  };

  renderDeleteReportAttachmentModal = () =>
    this.state.modalDeleteReportAttachmentVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
            <div className="bx--modal-container">
                <div className="bx--modal-header">
                    <h3 className="bx--modal-header__heading">Delete Attachment</h3>
                    <Button
                        className="bx--modal-close"
                        renderIcon={Close16}
                        onClick={this.handleDeleteReportAttachmentModalVisibility}
                    />
                </div>

                <div className="bx--modal-content">
                    <div className="bx--row bx--modal-content-detail">
                        <div className="bx--col-lg-12 bx--col-md-12">
                            <h5 className="align-center">
                                {`Press confirm to delete ${this.state.selectedAttachment.name}`}
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="bx--modal-footer">
                    <Button
                        className="button--max-width"
                        kind="secondary"
                        onClick={this.handleDeleteReportAttachmentModalVisibility}
                    >
                        Cancel
                    </Button>
                    <Button className="button--max-width" kind="primary" onClick={this.deleteReportAttachment}>
                        Confirm
                    </Button>
                </div>
            </div>
        </div>
    );

  handleDeleteReportAttachmentModalVisibility = () => {
    this.setState((oldState) => ({
        modalDeleteReportAttachmentVisible: !oldState.modalDeleteReportAttachmentVisible,
        selectedAttachment: null,
    }));
  }

  ifManageReportAttachment = (user) => {
  console.log(user)
    if(IsInRole(user, 'Administrator')) return true;
    if(IsInRole(user, 'Compiler') && this.state.audit?.checkList?.status.reportingName !== 'Approved' && this.state.audit?.checkList?.status.reportingName !== 'Completed')
      return true
    
      return false;
  }
  //#endregion
  
  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) {
      return (
        <Online>
          <>
            {CanExecuteAction(
                'Audit',
                'Reporting',
                user,
                "",
                'DownloadAuditZip',
                this.state.audit.checkList,
                this.state.audit.auditors //RITM0736117
              ) ?
              <Button
                renderIcon={Download16}
                onClick={() =>
                  this.DownloadAuditZipAction() //RITM0646764
                }
              >
                Download Report
              </Button> : null }
          </>
        </Online>
      )
    };
    const { idStatus } = this.state.audit.checkList;

    return (
      <Online>
        <>
          {CanExecuteAction(
            'Audit',
            this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
            user,
            "",
            'DownloadAuditZip',
            this.state.audit.checkList,
            this.state.audit.auditors //RITM0736117
          ) ?
          <Button
            renderIcon={Download16}
            onClick={() =>
              this.DownloadAuditZipAction() //RITM0646764
            }
          >
            Download Report
          </Button> : null }
          {CanExecuteAction(
            'Audit',
            'Reporting',
            user,
            idStatus,
            'Submit',
             this.state.audit.checkList,
            this.state.audit.auditors //RITM0736117
          ) ? (
            <Button
              renderIcon={Send16}
              onClick={() =>
                this.submitReportAction() //RITM0646764
              }
            >
              Submit Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Audit',
            this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
            user,
            idStatus,
            'Approve',
            this.state.audit.checkList
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick(
                  'approvereport',
                  'Approve',
                  null,
                  false,//RITM0735062
                  false,
                  null
                )
              }
            >
              Approve Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Audit',
            this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
            user,
            idStatus,
            'Consolidate',
            this.state.audit.checkList
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() =>
                this.batchActionClick('consolidatereport', 'Approve', null, false, false, null)
              }
            >
              Consolidate Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Audit',
            this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
            user,
            idStatus,
            'Reject',
            this.state.audit.checkList
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectreport', 'Reject', null, false, true, null)
              }
            >
              Reject Report
            </Button>
          ) : null}

          {CanExecuteAction(
            'Audit',
            this.state.audit.newCarManagement === false ? 'Reporting' : 'FindingReporting',
            user,
            idStatus,
            'RejectConsolidate',
            this.state.audit.checkList
          ) ? (
            <Button
              renderIcon={Error16}
              onClick={() =>
                this.batchActionClick('rejectconsolidatereport', 'Reject', null, false, true, null)
              }
            >
              Reject Report
            </Button>
          ) : null}

          {/* {CanExecuteAction('Audit', 'Reporting', user, idStatus, 'Delete') ? (
          <Button
            renderIcon={Delete16}
            onClick={() =>
              this.batchActionClick('deletereport', 'Delete', null, false, false, null)
            }
          >
            Delete
          </Button>
        ) : null} */}
        </>
      </Online>
    );
  };

  getUsersInRole = (role, idEntity) => {
    me.getWithParam('users', {
      params: { Role: role, IdEntity: idEntity, includeAdmins: true },
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ROLE, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  getTemplate = () => {
    const result = [];
    const map = new Map();
    this.state.audit.checkList.answers.map((answer) => {
      if (!map.has(answer.idAuditCheckListTemplate)) {
        map.set(answer.idAuditCheckListTemplate, true);
        result.push({...answer.template, /*DEV550*/ active: answer.active});
      }
    });
    const orderResult = [];
    var defaultTemplate = result.filter(x => x.code === 'DEFAULT');
    var noDefaultTemplate = result.filter(x => x.code !== 'DEFAULT');

    defaultTemplate.map(item => {
      orderResult.push(item);
    })

    noDefaultTemplate.map(item => {
      orderResult.push(item);
    })

    return orderResult;
  };

  toggleActiveTemplateQuestions = (idCheckListTemplate) => {
    const updatedAnswer =this.state.audit.checkList.answers.map(answer => {
      if(answer.idAuditCheckListTemplate === idCheckListTemplate) return {...answer, active: !answer.active}
      return {...answer}
    })
    const copyOfAudit = {...this.state.audit}
    copyOfAudit.checkList.answers = updatedAnswer
    this.setState({ audit: copyOfAudit })
  }

  getSections = (idTemplate) => {
    const result = [];
    const map = new Map();
    this.state.audit.checkList.answers.map((item) => {
      if (
        item.idAuditCheckListTemplate === idTemplate &&
        !map.has(item.idAuditCheckListTemplateSection)
      ) {
        map.set(item.idAuditCheckListTemplateSection, true);
        result.push(item.section);
      }
    });
    return result.sort((a, b) => a.ranking - b.ranking);
  };

  getQuestionAnswer = (idSection) => {
    const result = [];
    this.state.audit.checkList.answers.map((item) => {
      if (item.idAuditCheckListTemplateSection === idSection && item.question) result.push(item);
    });
    return result.sort((a, b) => {
      // const codeA = a.question.code.toUpperCase();
      // const codeB = b.question.code.toUpperCase();
      
      // RITM0567424
      const codeA = a.question.ranking
      const codeB = b.question.ranking;
      return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;
    });
    // return result.sort((a, b) => a.question.ranking - b.question.ranking);
  };

  getRequirementAnswer = (idSection) => {
    const result = [];
    this.state.audit.checkList.answers.map((item) => {
      if (item.idAuditCheckListTemplateSection === idSection && item.requirement) result.push(item);
    });
    return result.sort((a, b) => {
      const codeA = a.requirement.code
      const codeB = b.requirement.code;
      return codeA < codeB ? -1 : codeA > codeB ? 1 : 0;
    });
  };

  getItems = async () => {
    let audit = null;

    try {
      audit = await this.repository.getAudit(this.props.match.params.id);
      audit.auditorsNoSaipem.map((el) => {
        audit.auditors.push({ ...el, id: uuid() });
      });

      audit.auditeeNoSaipem.map((el) => {
        audit.auditees.push({ ...el, id: uuid() });
      });
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.REPORT, apioperation.GET)
      );
    }
    return audit;
  };

  async getEmployees() {
    try {
      const employees = await this.repository.getEmployees();
      this.setState({
        employees,
      });
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.EMPLOYER, apioperation.GET)
      );
    }
  }

  // /Status Action
  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.audit.id],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(`/audit/${apiEndpoint}`, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.AUDIT, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            tabsLoading: true,
          });

          this.props.history.push('/listofaudit');
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.AUDIT, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  refreshAudit = async () => {
    this.setState({
      tabsLoading: true,
    });
    const audit = await this.getItems();
    this.setState({
      audit,
      tabsLoading: false,
      editingDisabled: !this.CanUserEdit(audit),
    });
  };

  deleteAttachment = async () => {
    try {
      this.setState({ isSubmitted: true });
      await api.deleteData(
        `/audit/${this.state.audit.id}/attachment/${this.state.selectedAttachment.fileIdentifier}`
      );
      this.setState((prevState) => {
        const audit = { ...prevState.audit };
        audit.attachments = prevState.audit.attachments.filter(
          (a) => a.id !== prevState.selectedAttachment.id
        );
        return { audit };
      });
      return this.handleDeleteAttachmentModalVisibility();
    } catch (error) {
      return showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.FileUpload, apioperation.DELETE)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  renderDeleteAttachmentModal = () =>
    this.state.modalDeleteAttachmentVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Attachment</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteAttachmentModalVisibility}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">
                  {`Press confirm to delete ${this.state.selectedAttachment.name}`}
                </h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteAttachmentModalVisibility}
            >
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.deleteAttachment}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderTitle = () => (
    <div className="bx--row auditReportTitleRow">
      <div className="bx--col-lg-12 bx--col-md-12">
        {this.state.tabsLoading ? (
          <SkeletonText />
        ) : (
          <div className="bx--row">
            <div className="">
              <h5>{this.state.audit.auditCode}</h5>
            </div>
            <div className="bx--col-lg-2 bx--col-md-2">
              <StatusTag value={this.state.audit.checkList.status.reportingName} />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  renderMainInformationTitle = () =>
    this.state.mainInformationOpened ? (
      <span className="mainInformationHeaderTitleExpanded">Main Information</span>
    ) : (
      <>
        <div className="bx--row">
          <div className="bx--col-lg-3 bx--col-md-3 mainInformationReportAccordion">
            <span className="mainInformationHeaderTitle">Main Information</span>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-3 bx--col-md-2 mainInformationPadding">
            {/* RITM0945977 */}
            {/* <span className="bold">Division</span> */}
            <span className="bold">Business Line</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.state.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">{this.state.audit.division.name}</span>
                )}
              </div>
            </div>
          </div>
          <div className="bx--col-lg-5 bx--col-md-3 mainInformationPadding main-information-detail">
            <span className="bold">Company</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.state.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">
                    {this.state.audit.company ? this.state.audit.company.name : 'N.A.'}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="bx--col-lg-4 bx--col-md-3 mainInformationPadding">
            <span className="bold">Audited Site</span>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 mainInformationPadding">
                {this.state.tabsLoading ? (
                  <SkeletonText />
                ) : (
                  <span className="font-small">
                    {this.state.audit.workSites.map((item) => item.name).join(', ')}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );

  renderHeader = () => (
    <PageBreadCrumb
      linkTo="/listofaudit?isBack"
      linkText="Audit List"
      titleLeft="Audit"
      titleCenter={
        this.state.audit && this.state.audit.auditCode ? `ID: ${this.state.audit.auditCode}` : ''
      }
      titleRight={
        this.state.audit && this.state.audit.checkList
          ? this.state.audit.checkList.status.reportingName
          : null
      }
      batchActions={
        this.state.audit?.checkList?.notificationForm?.savedOn != null
          ? this.getStatusActions(this.context.user)
          : null
      }
      showButtonHistory={this.showButtonHistory()}
    />
  );

  updateCheckList = async () => {
    // if (this.validationsAnswer.allValid()) { //CONTROLLO INSERITO NEL SUBMIT
    try {
      this.setState({ isSubmitted: true });
      await api.put('/audit/checklist', this.state.audit);
      this.repository.updateCachedAudit(this.state.audit);
      showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        getSuccess(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
    // } else {
    //  this.validationsAnswer.showMessages();
    //  showNotification.warning(`${entitiesLabels.WARNING}`, "${entitiesLabels.AUDIT} required fields are missing  ");
    //  this.forceUpdate();
    // }
  };

  updatePersonnel = async () => {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/audit/personnel', this.state.audit);
      this.repository.updateCachedAudit(this.state.audit);
      showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        getSuccess(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  updateConsideration = async () => {
    try {
      this.setState({ isSubmitted: true });
      await api.put('/audit/consideration', this.state.audit);
      this.repository.updateCachedAudit(this.state.audit);
      showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        getSuccess(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(entitiesLabels.AUDIT, apioperation.PUT)
      );
    } finally {
      this.setState({ isSubmitted: false });
    }
  };

  checkActivityValidDate = () => {
    const startDate = this.state.audit.startDate ? moment(this.state.audit.startDate).format('YYYY-MM-DD') : null;
    const endDate = this.state.audit.endDate ? moment(this.state.audit.endDate).format('YYYY-MM-DD') : null;

    var validDate = true;
    this.state.activitiesData?.forEach(activity => {
      let activityDate = activity.date ? moment(activity.date).format('YYYY-MM-DD') : null; //RITM1091064 - Audit Report Start End Date Fix
      console.log("date", activityDate) //RITM1091064 - Audit Report Start End Date Fix
      console.log("sdate", startDate)
      console.log("edate", endDate)
    
      if(activityDate > endDate || activityDate < startDate){ //RITM1091064 - Audit Report Start End Date Fix
        validDate = false;          
      }
    });

    if(this.state.activitiesData?.length === 0){
      console.log(this.state.audit.checkList.notificationForm?.activities)
      this.state.audit.checkList.notificationForm?.activities?.forEach(activity => {
        let activityDate = activity.date ? moment(activity.date).format('YYYY-MM-DD') : null;
        console.log("date", activityDate)
        console.log("sdate", startDate)
        console.log("edate", endDate)

        if(activityDate > endDate || activityDate < startDate){
          validDate = false;          
        }
      });
    }

    return validDate;
  }

  updateMainInformation = async () => {
    if (this.validator.allValid()) {      
      if(this.checkActivityValidDate()){      
        try {
          this.setState({ isSubmitted: true });
          await api.put('/audit/maininformation', this.state.audit);
          this.repository.updateCachedAudit(this.state.audit);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.AUDIT, apioperation.PUT)
          );
        } catch (error) {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(entitiesLabels.AUDIT, apioperation.PUT)
          );
        } finally {
          this.setState({ isSubmitted: false });
        }
      }
      else{
        const startDate = this.state.audit.startDate ? moment(this.state.audit.startDate).format('YYYY-MM-DD') : null;
        const endDate = this.state.audit.endDate ? moment(this.state.audit.endDate).format('YYYY-MM-DD') : null;

        showNotification.error(
          `${entitiesLabels.ERROR}`,
          `There are some ActiviyDate that do not fall within the range of ${startDate} and ${endDate}`
        );
        this.forceUpdate();
      }
    } else {
      this.validator.showMessages();

      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.AUDIT} required fields are missing`
      );
      this.forceUpdate();
    }
  };

  validationSendNotification() {
    if (this.validator.allValid()) {
      this.setState({
        validationSend: false,
      });
    } else {
      this.setState({
        validationSend: true,
      });
    }
  }

  updateNotificationData = async (item) => {
    if (this.validator.allValid()) {
      this.updateMainInformation();

      if(this.checkActivityValidDate()){
        try {
          this.setState({ isSubmitted: true, validationSend: false });
  
          item.savedOn = new Date();
          await api.put('/audit/notification', item);
  
          const { audit } = this.state;
          audit.checkList.notificationForm = item;
          this.repository.updateCachedAudit(audit);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.NOTIFICATION, apioperation.PUT)
          );
        } catch (error) {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(entitiesLabels.NOTIFICATION, apioperation.PUT)
          );
        } finally {
          this.setState({ isSubmitted: false });
        }
      }      
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.AUDIT} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  setActivitiesData = (items) => {
    console.log(items)
    this.setState({
      activitiesData: items
    })
  }

  sendNotificationData = async (notificationItem) => {
    if (this.validator.allValid()) {
      const item = notificationItem;
      try {
        this.setState({ isSubmitted: true });
        item.sendedOn = new Date();
        item.sendedBy = this.context.user.email;
        await api.put('/audit/notification/send', item);

        const { audit } = this.state;
        audit.checkList.notificationForm = item;
        this.repository.updateCachedAudit(audit);
        showNotification.success(`${entitiesLabels.SUCCESS}`, 'Notification sent successfully');
      } catch (error) {
        item.sendedOn = null;
        item.sendedBy = null;
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          'Error occurred, Notification not sent successfully'
        );
      } finally {
        this.setState({ isSubmitted: false });
      }
    }
  };

  handleRequirementDelete = async () => {
    try {
      this.setState({ isSubmitted: true });
      await api.delete('/audit/checklistquestion/', this.state.requirementToDelete);
      const { answers } = this.state.audit.checkList;
      const index = answers.findIndex(
        (qa) => qa.requirement?.id === this.state.requirementToDelete
      );
      answers.splice(index, 1);
      this.setState((prevState) => {
        const audit = { ...prevState.audit };
        audit.checkList.answers = answers;
        return { audit };
      });
      showNotification.success(
        `${entitiesLabels.SUCCESS}`,
        getSuccess(entitiesLabels.NOTIFICATION, apioperation.DELETE)
      );
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(entitiesLabels.NOTIFICATION, apioperation.DELETE)
      );
      throw error;
    } finally {
      this.setState((oldState) => ({
        isSubmitted: false,
        modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
        requirementToDelete: null,
      }));
    }
  };

  handleRequirementDeleteCancel() {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: null,
    }));
  }

  handleDeleteAttachmentModalVisibility() {
    this.setState((oldState) => ({
      modalDeleteAttachmentVisible: !oldState.modalDeleteAttachmentVisible,
      selectedAttachment: null,
    }));
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows,
    approverWarning = null //RITM0646764
  ) {
    // if (this.validationsAnswer.allValid()) {  // answer will be validated only from BE
      const { audit } = this.state;
      const idEntity = audit.idDivision;
      this.setState({
        approvalModalAction: actionName,
        isApprovalModalOpen: true,
        isLoadingApproverOptions: true,
        withApprover,
        approverWarning, //RITM0646764
        selectedData: selectedRows,
        approverRole,
        approvalEndpoint: actionKey,
        approvalNotesRequired,
      });
      if (withApprover) this.getUsersInRole(approverRole, idEntity);
    // } else {
    //   this.validationsAnswer.showMessages();
    //   showNotification.warning(
    //     `${entitiesLabels.WARNING}`,
    //     `${entitiesLabels.AUDIT} required fields are missing,  please remember to save Requirement section before you submit Audit  `
    //   );
    //   this.forceUpdate();
    // }
  }

  submitReportAction = () => { //RITM0646764
    this.setState({
      isSubmitted: true,
    });
    api
      .get(`/audit/checkanswersforsubmitauditreport/`, this.state.audit.id)
      .then((response) => {
        this.batchActionClick('submitreport', 'Submit', 'Data Approver', true, false, null, response.data || null)
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.AUDIT_REPORT, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  }

  DownloadAuditZipAction = () => { //RITM0646764
    this.setState({
      isSubmitted: true,
    });

    let input = {
      ids: [this.state.audit.id],
      isSingle: true
    };

    api.postBlob(`/audit/downloadzipmassiveextraction`, input)
      .then((response) => {
        const link = document.createElement('a');
        // Browsers that support HTML5 download attribute
        if (link.download !== undefined) {
          var currentdate = new Date(); 
          var datetime =  (currentdate.getMonth()+1).toString() +
                  currentdate.getDate().toString() +
                  currentdate.getFullYear().toString() +
                  currentdate.getHours().toString() +  
                  currentdate.getMinutes().toString() + 
                  currentdate.getSeconds().toString();
          var fileName = 'Audit_' + this.state.audit.auditCode + '.zip';

          const url = URL.createObjectURL(response.data);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((error) => {
        showNotification.error(getError(error, entitiesLabels.AUDITMASSIVEEXTRACTION_GETAUDITS, apioperation.POST));
      })
      .finally(() => {
        this.setState({ 
          isSubmitted: false
        });
      });
  }

  IsRowSelectable() {
    const auditItem = this.state.audit;
    if (
      auditItem == null ||
      auditItem.checkList == null ||
      auditItem.checkList.idStatus === STATUS.Consolidated
    ) {
      return false;
    }
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  downloadFile(blob, fileName) {
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  showAddRequirement(Template, Section) {
    this.setState((oldState) => ({
      modalAddRequirementVisible: !oldState.modalAddRequirementVisible,
      addRequirementTemplate: Template,
      addRequirementSection: Section,
    }));
  }

  showModifyRequirement(idCheckListAnswer, requirement) {
    this.setState((oldState) => ({
      modalUpdateRequirementVisible: !oldState.modalUpdateRequirementVisible,
      requirementToModify: requirement,
      checkListRequirementToModify: idCheckListAnswer,
    }));
  }

  showDeleteRequirement(id) {
    this.setState((oldState) => ({
      modalDeleteRequirementVisible: !oldState.modalDeleteRequirementVisible,
      requirementToDelete: id,
    }));
  }

  newCheckListRequirementAdded(item) {
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalAddRequirementVisible = !prevState.modalAddRequirementVisible;
      state.isSubmitted = false;
      state.audit.checkList.answers = prevState.audit.checkList.answers.concat({...item, active: true});
      this.repository.updateCachedAudit(this.state.audit);
      return state;
    });
  }

  checkListRequirementUpdated(item) {
    const { answers } = this.state.audit.checkList;
    const index = answers.findIndex((qa) => qa.requirement?.id === item.id);
    answers[index].requirement = item;
    this.setState((prevState) => {
      const state = { ...prevState };
      state.modalUpdateRequirementVisible = !prevState.modalUpdateRequirementVisible;
      state.isSubmitted = false;
      state.audit.checkList.answers = answers;
      this.repository.updateCachedAudit(this.state.audit);
      return state;
    });
  }

  renderRequirementDeleteModal = () =>
    this.state.modalDeleteRequirementVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h4 className="bx--modal-header__heading">Delete Custom Requirement</h4>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleRequirementDeleteCancel}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row" />
            <div className="bx--col-lg-12 bx--col-md-12">
              <h5 className="align-center">Press confirm to delete selected custom requirement</h5>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleRequirementDeleteCancel}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.handleRequirementDelete}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  //RITM0646764
  //* *************** ATTACHMENT **************** START
  showModalAttachment = (id) => {
    this.setState({
      idAnswerAttachment: id,
      isOpenModalAttachment: true,
    });
  };

  closeModalAttachment = () => {
    this.setState({
      isOpenModalAttachment: false,
    });
  };

  modalAttachment(user) {
    const modalHeader = {
      title: 'Attachments',
      iconDescription: 'Close',
      buttonOnClick: () => this.closeModalAttachment(),
    };

    return (
      <>
      <Loading active={this.state.isLoadingNotificationFile} withOverlay />
        {this.state.isOpenModalAttachment ? (
          <ComposedModal className="light-modal" open danger="false" onClose={() => false}>
            <ModalHeader className="margin-modal" {...modalHeader}>
              <p />
            </ModalHeader>
            <ModalBody className="margin-modal">
              {(IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler')) && (
                <div className="bx--col-lg-6 bx--col-md-6 element-detail-layout">
                  <FileUpload
                    Container="saipem"
                    StoragePath="audit"
                    onUpload={this.onUploadAnswer}
                    disabled={this.state.editingDisabled}
                  />
                </div>
              )}
              <TableContainer>
                <Table>
                  <TableHead className="colorgray">
                    <TableRow>
                      <TableHeader>Name</TableHeader>
                      <TableHeader>Size</TableHeader>
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.audit?.checkList.answers.map((answer) =>
                      answer.attachments !== undefined && answer.attachments != [] && answer.id === this.state.idAnswerAttachment ? (//RITM0945977
                        answer.attachments < 1 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                        ) : (
                          answer.attachments.map((item) => (
                            <TableRow key={`row_${item.id}`}>
                              <TableCell key={`cell_1_${item.id}`}>
                                {item?.name}
                              </TableCell>
                              <TableCell key={`cell_2_${item.id}`}>
                                {sizeFormat(item?.size)}
                              </TableCell>
                              <TableCell
                                key={`action-${item.id}`}
                                className="tableActions align-center"
                              >
                                {this.state.downloading === item.id ? (
                                  <div>
                                    <InlineLoading
                                      description=""
                                      iconDescription="downloading.."
                                      status="active"
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    <Online>
                                      <DownLoadButton
                                        onError={(error) => {
                                          showNotification.error(`${entitiesLabels.ERROR}`,
                                            getError(
                                              error,
                                              entitiesLabels.FileUpload,
                                              apioperation.GET
                                            )
                                          );
                                        }}
                                        onDownLoadStart={() =>
                                          this.setState({
                                            downloading: item.id,
                                          })
                                        }
                                        onDownLoadEnd={() => this.setState({ downloading: null })}
                                        apiUrl={`/audit/${this.state.audit.id}/downloadanswerattachment/${item.fileIdentifier}`}
                                        fileName={item?.name}
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled={this.state.editingDisabled}
                                      />
                                    </Online>
                                    <Offline>
                                      <Button
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled
                                      />
                                    </Offline>
                                    <Online>
                                      {(IsInRole(user, 'Administrator') ||
                                        IsInRole(user, 'Compiler')) && (
                                        <Button
                                          onClick={() => this.onDeleteAttachmentAnswer(item.id)}
                                          size="small"
                                          renderIcon={Delete16}
                                          iconDescription="Delete"
                                          kind="ghost"
                                          disabled={this.state.editingDisabled}
                                        />
                                      )}{' '}
                                    </Online>
                                    <Offline>
                                      <Button
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled
                                      />
                                    </Offline>
                                  </div>
                                )}
                              </TableCell>
                            </TableRow>
                          ))
                        )
                      ) : (
                        ''
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </ModalBody>
          </ComposedModal>
        ) : (
          <div />
        )}
      </>
    );
  }

  onDeleteAttachmentAnswer = async (id) => {
    const answer = this.state.audit.checkList.answers.find(
      (item) => item.attachments.count != 0 && item.id === this.state.idAnswerAttachment
    );
    if(answer !== null && answer !== undefined){
      const selectedItem = answer.attachments.find((item) => item.id === id);
      try {
        this.setState({ isSubmitted: true });
        const { fileIdentifier } = selectedItem;
  
        await audit.deleteAttach(
          `/audit/${this.state.audit.id}/deleteanswerattachment/${this.state.idAnswerAttachment}/answer/${fileIdentifier}`
        );
        const index = answer.attachments.indexOf(selectedItem);
        if (index > -1) {
          answer.attachments.splice(index, 1);
        }
      } catch (error) {
        return showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ATTACHMENT, apioperation.DELETE)
        );
      } finally {
        this.setState({ isSubmitted: false });
      }
    }    
  }

  onUploadAnswer = async (fileIdentifier, fileName, fileType, size) => {
    const newAttach = {
      id: uuid(),
      fileIdentifier: fileIdentifier.blobName,
      name: fileName,
      contentType: fileType,
      size,
    };
    this.uploadAnswerAttachment(this.state.idAnswerAttachment, newAttach);
  }

  uploadAnswerAttachment = async (idAnswerAttachment, newAttach) => {
    const answer = this.state.audit.checkList.answers.find(
      (item) => item.attachments.count != 0 && item.id === idAnswerAttachment
    );
    const index = this.state.audit.checkList.answers.indexOf(answer);
    this.setState({ isSubmitted: true });
    await api
      .post(
        `/audit/${this.state.audit.id}/uploadanswerattachments/${idAnswerAttachment}`,
        newAttach
      )
      .then((response) => {
        console.log(response.data)
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`,getSuccess(entitiesLabels.ATTACHMENT, apioperation.POST));

          answer.attachments.push(response.data);
          this.setState((prevState) => {
            const audit = { ...prevState.audit };
            audit.checkList.answers[index] = answer;
            this.repository.updateCachedAudit(audit);
            return { audit };
          });
        } else {
          showNotification.error();
        }
        this.setState({ isSubmitted: false });
      })
      .catch((error) => {
        this.setState({ isSubmitted: false });
        return showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.ATTACHMENT, apioperation.POST)
        );
      });
  }
  //* *************** ATTACHMENT **************** END

  renderTabs = (user) => {
    const validations = {
      startdate: this.validator.message('start date', this.state.audit.startDate, 'required'),
      enddate: this.validator.message('end date', this.state.audit.endDate, 'required'),
      maininformation: this.validator.message(
        'Main informationdate ',
        this.state.audit.startDate && this.state.audit.endDate,
        'required'
      ),
    };
    return (
      <>
        {this.state.modalAddRequirementVisible ? (
          <CheckListRequirement
            CheckList={this.state.audit.checkList}
            Section={this.state.addRequirementSection}
            Template={this.state.addRequirementTemplate}
            onSave={this.newCheckListRequirementAdded}
            onCancel={this.showAddRequirement}
          />
        ) : null}
        {this.state.modalUpdateRequirementVisible ? (
          <CheckListRequirement
            idCheckListAnswer={this.state.checkListRequirementToModify}
            Requirement={this.state.requirementToModify}
            onUpdate={this.checkListRequirementUpdated}
            onCancel={this.showModifyRequirement}
          />
        ) : null}
        {this.renderHeader()}
        {/* {this.renderTitle()} */}
        {this.renderLoadingModal()}
        {this.renderRequirementDeleteModal()}
        {this.renderDeleteAttachmentModal()}
        {this.renderDeleteReportAttachmentModal()} {/* RITM0646764 */}
        <div className="mainContainer">
          <div className="bx--grid content full-width mainContainer ">
            <WFActionModal
              show={this.state.isApprovalModalOpen}
              title={`${this.state.approvalModalAction} Audit`}
              action={this.state.approvalModalAction}
              withApprover={this.state.withApprover}
              approverWarning={this.state.approverWarning} //RITM0646764
              approver={this.state.approver}
              approverRole={this.state.approverRole}
              approverOptions={this.state.approvers}
              isLoadingOperation={this.state.isLoadingWFOperation}
              onApproverSelect={this.handleApproverSelect}
              isLoadingOptions={this.state.isLoadingApproverOptions}
              onCancel={this.handleCloseApprovalModal}
              onConfirm={this.handleConfirmApprovalModal}
              onApprovalNotesChange={this.handleApprovalNotesChange}
              approvalNotes={this.state.approvalNotes}
              approvalNotesRequired={this.state.approvalNotesRequired}
              validationMessages={this.state.approvalValidationMessages}
            />
            {this.modalAttachment(user)}
            {this.state.audit && this.state.audit.checkList && (
              <HistoryTable
                entityId={this.state.audit.checkList.id}
                isOpenModal={this.state.isHistoryModalOpen}
                onClose={() => this.closeModalHistory()}
              />
            )}
            <div className="bx--row">
              <Accordion>
                <AccordionItem
                  onHeadingClick={this.onMainInformationAccordionClick}
                  className="mainInformationTitle"
                  title={this.renderMainInformationTitle()}
                >
                  {!this.state.tabsLoading ? (
                    <>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          {/* RITM0945977 */}
                          {/* <div className="bx--col-lg-2 bx--col-md-2">Division</div> */}
                          <div className="bx--col-lg-2 bx--col-md-2">Business Line</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.division.name}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Company</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.company?.name}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Audit code</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.auditCode}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Site/s audited</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.workSites.map((item) => item.name).join(', ')}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Project/s audited</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.projects.map((item) => item.name).join(', ')}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Type of audit</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.auditType.name}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Target of audit</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.target.name}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Audit Scopes</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {this.state.audit.scopes.map((item) => item.name).join(', ')}
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-2 bx--col-md-2">Audit Remote</div>
                          <div className="bx--col-lg-10 bx--col-md-6">
                            {/*this.state.audit.auditRemote?'Yes':'No'*/}
                            <Checkbox
                              id="isAuditRemote"
                              alt="model"
                              labelText=""
                              checked={this.state.audit.auditRemote || false}
                              onChange={this.onAuditRemoteChange}
                            />
                          </div>
                        </div>
                      </Tile>
                      <Tile className="mainInformation--tile">
                        <div className="bx--row">
                          <div className="bx--col-lg-6 bx--col-md-12">
                            <DatePicker
                              id="date-picker-startdate"
                              datePickerType="range"
                              dateFormat="d/m/Y"
                              onChange={this.onStartDateChange}
                              // value={this.state.audit.startDate}
                              className="carbondatepicker"
                              light
                              locale="en"
                              disabled={this.state.editingDisabled}
                            >
                              <DatePickerInput
                                id="date-picker-input-startDate"
                                labelText="Start Date*"
                                value={
                                  this.state.audit.startDate
                                    ? moment(this.state.audit.startDate).format('DD/MM/Y')
                                    : ''
                                }
                                iconDescription="start date"
                                disabled={this.state.editingDisabled}
                                invalid={validations.startdate != null}
                              />                              
                              <DatePickerInput
                                id="date-picker-input-EndDate"
                                labelText="End Date*"
                                value={
                                  this.state.audit.endDate
                                    ? moment(this.state.audit.endDate).format('DD/MM/Y')
                                    : ''
                                }
                                iconDescription="end date"
                                invalid={validations.enddate != null}
                                disabled={this.state.editingDisabled || !this.state.audit.startDate}
                              />
                            </DatePicker>
                            {validations.startdate}
                            {validations.enddate}
                          </div>
                        </div>
                        <div className="bx--row">
                          <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                            <Button
                              size="default"
                              renderIcon={Save16}
                              kind="primary"
                              onClick={this.updateMainInformation}
                              disabled={this.state.editingDisabled}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Tile>
                      <Tile className="bx--tile bx--tile--light">
                        <div className="bx--col-lg-6 bx--col-md-6">
                          <Online>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUpload}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"
                            />
                          </Online>
                          <Offline>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUpload}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"
                            />
                          </Offline>
                        </div>
                      </Tile>
                      <Tile className="bx--tile bx--tile--light">
                        <div className="bx--col-lg-12 bx--col-md-12">
                          <TableContainer className="bx--grid--full-width">
                            <Table>
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader>Name</TableHeader>
                                  <TableHeader>Size</TableHeader>
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.audit.attachments < 1 ? (
                                  <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                                ) : (
                                  this.state.audit.attachments.map((item) => (
                                    <TableRow key={`row_${item.id}`}>
                                      <TableCell key={`cell_1_${item.id}`}>{item.name}</TableCell>
                                      <TableCell key={`cell_2_${item.id}`}>
                                        {sizeFormat(item.size)}
                                      </TableCell>
                                      <TableCell
                                        key={`action-${item.id}`}
                                        className="tableActions align-center"
                                      >
                                        {this.state.downloading === item.id ? (
                                          <div>
                                            <InlineLoading
                                              description=""
                                              iconDescription="downloading.."
                                              status="active"
                                            />
                                          </div>
                                        ) : (
                                          <div>
                                            <Online>
                                              <DownLoadButton
                                                onError={(error) => {
                                                  showNotification.error(
                                                    `${entitiesLabels.ERROR}`,
                                                    getError(
                                                      error,
                                                      entitiesLabels.FileUpload,
                                                      apioperation.GET
                                                    )
                                                  );
                                                }}
                                                onDownLoadStart={() =>
                                                  this.setState({ downloading: item.id })
                                                }
                                                onDownLoadEnd={() =>
                                                  this.setState({ downloading: null })
                                                }
                                                apiUrl={`/audit/${this.state.audit.id}/attachment/${item.fileIdentifier}`}
                                                fileName={item.name}
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                disabled={this.state.editingDisabled}
                                              />
                                              <Button
                                                onClick={() => this.onDeleteAttachment(item.id)}
                                                size="small"
                                                renderIcon={Delete16}
                                                iconDescription="Delete"
                                                kind="ghost"
                                                disabled={this.state.editingDisabled}
                                              />
                                            </Online>
                                            <Offline>
                                              <Button
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                disabled
                                              />
                                              <Button
                                                onClick={() => this.onDeleteAttachment(item.id)}
                                                size="small"
                                                renderIcon={Delete16}
                                                iconDescription="Delete"
                                                kind="ghost"
                                                disabled
                                              />
                                            </Offline>
                                          </div>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Tile>

                      <div className="bx--row">
                        {/* {rows.map(item =>
                        <div className="divShowDocument divShowDocumentT" key={item.id}>
                            <FormLabel>{item.attachment.fileIdentifier}</FormLabel>
                            <Button key={item.id + 'dw'} renderIcon={View16} kind="ghost" 
                            size="default"
                                iconDescription="DW" tooltipAlignment="center"
                                hasIconOnly />
                            <Button key={item.id + 'del'} renderIcon={Delete16} kind="ghost" 
                            size="default"
                                iconDescription="Del" tooltipAlignment="center"
                                onClick={() => this.remove(item.id)}
                                hasIconOnly />
                        </div>
                    )
                    } */}
                      </div>
                    </>
                  ) : (
                    ''
                  )}
                </AccordionItem>
              </Accordion>
              
              {/* START RITM0646764 */}
              {!this.state.mainInformationOpened && (
                this.state.tabsLoading ? (
                  <SkeletonText />
                ) :
                <Tile className="bx--tile py-16px bx--col-lg-12 bx--col-md-12 mt-16px mb-20px">
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-12">
                      <DatePicker
                        id="date-picker-startdate"
                        datePickerType="range"
                        dateFormat="d/m/Y"
                        onChange={this.onStartDateChange}
                        // value={this.state.audit.startDate}
                        className="carbondatepicker"
                        light
                        locale="en"
                        disabled={this.state.editingDisabled}
                      >
                        <DatePickerInput
                          id="date-picker-input-startDate"
                          labelText="Start Date*"
                          value={
                            this.state.audit.startDate
                              ? moment(this.state.audit.startDate).format('DD/MM/Y')
                              : ''
                          }
                          iconDescription="start date"
                          disabled={this.state.editingDisabled}
                          invalid={validations.startdate != null}
                        />
                        <DatePickerInput
                          id="date-picker-input-EndDate"
                          labelText="End Date*"
                          value={
                            this.state.audit.endDate
                              ? moment(this.state.audit.endDate).format('DD/MM/Y')
                              : ''
                          }
                          iconDescription="end date"
                          invalid={validations.enddate != null}
                          disabled={this.state.editingDisabled || !this.state.audit.startDate}
                        />
                      </DatePicker>
                      {validations.startdate}
                      {validations.enddate}
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-12 main-information-button">
                      <Button
                        className="mt-16px"
                        size="default"
                        renderIcon={Save16}
                        kind="primary"
                        onClick={this.updateMainInformation}
                        disabled={this.state.editingDisabled}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </Tile>
              )}
              {/* END RITM0646764 */}

              {validations.maininformation ? (
                <div className="srv-validation-message">
                  {' '}
                  Enter the start and end data in the main information{' '}
                </div>
              ) : null}
            </div>

            {this.state.audit?.checkList?.notificationForm?.sendedOn != null ? (
              ''
            ) : this.state.tabsLoading ? (
              <div className="bx--col-lg-12 bx--tab-container">
                <TabsSkeleton className="bannerNotification" />
              </div>
            ) : (
              <div className="bx--row">
                <InlineNotification
                  kind={'warning'}
                  lowContrast={true}
                  title={'Warning'}
                  subtitle={'The Audit Notification has not been sent!'}
                  iconDescription=""
                  hideCloseButton="true"
                  style={{ maxWidth: 'none' }}
                />
              </div>
            )}

            <div className="bx--row">
              {this.state.tabsLoading ? (
                <div className="bx--col-lg-12 bx--tab-container">
                  <TabsSkeleton className="auditReportTab" />
                </div>
              ) : (
                <Tabs
                  ariaLabel="listbox"
                  className="auditReportTab"
                  iconDescription="show menu options"
                  onKeyDown={() => {}}
                  role="navigation"
                  selected={0}
                  tabContentClassName="auditReportTab"
                  triggerHref="#"
                  type="default"
                >
                  <Tab
                    href="#"
                    label="Notification Form"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                  >
                    <div>
                      <AuditNotificationForm
                        id="notificationForm"
                        NotificationFormData={this.state.audit.checkList.notificationForm}
                        minDate={moment(this.state.audit.openAt).format('DD/MM/Y')}
                        maxDate={moment(this.state.audit.openAt).endOf('M').format('DD/MM/Y')}
                        workSites={this.state.audit.workSites}
                        onSave={this.updateNotificationData}
                        onSend={this.sendNotificationData}
                        setActivitiesData={this.setActivitiesData}
                        disabled={this.state.editingDisabled}
                        validationDateSend={this.state.validationSend}
                        startDate={this.state.audit.startDate || null}
                        endDate={this.state.audit.endDate || null}
                        // STEFANO 30/06/2021
                        // isTeamLeader={
                        //   this.state.audit.auditors.filter((el) => el.teamLeader)[0].id ==
                        //   this.context.user.id
                        // }
                        isTeamLeader={
                          this.state.audit.auditors.filter((el) => el.teamLeader)[0] ? 
                          this.state.audit.auditors.filter((el) => el.teamLeader)[0].id ==
                          this.context.user.id :
                          false
                        }
                        //STEFANO 30/06/2021

                      />
                    </div>
                  </Tab>
                  <Tab
                    href="#"
                    label="Consideration"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                    disabled={!this.state.audit.checkList.notificationForm.savedOn}
                  >
                    <div className="some-content">
                      <Tile light>
                        <div className="bx--row">
                          <div className="bx--col-lg-12 bx--col-md-12">
                            <FormGroup legendText="Report Summar (The mention of names and surnames must be done only if strictly necessary)">
                              <TextArea
                                maxLength={5000}
                                labelText=""
                                id="inputReportSummary"
                                name="inputReportSummary"
                                cols={250}
                                disabled={this.state.editingDisabled}
                                invalid={false}
                                invalidText="required"
                                light
                                placeholder=""
                                rows={10}
                                value={this.state.audit.reportSummary || ''}
                                onChange={this.onReportSummaryChange}
                              />
                            </FormGroup>
                          </div>
                          <div className="bx--col-lg-12 bx--col-md-12">
                            <FormGroup legendText="Introduction (The mention of names and surnames must be done only if strictly necessary)">
                              <TextArea
                                maxLength={5000}
                                labelText=""
                                id="inputIntroduction"
                                name="inputIntroduction"
                                cols={250}
                                disabled={this.state.editingDisabled}
                                invalid={false}
                                invalidText="required"
                                light
                                placeholder=""
                                rows={10}
                                value={this.state.audit.introduction || ''}
                                onChange={this.onIntroductionChange}
                              />
                            </FormGroup>
                          </div>
                          <div className="bx--col-lg-12 bx--col-md-12">
                            <FormGroup legendText="Conclusion (The mention of names and surnames must be done only if strictly necessary)">
                              <TextArea
                                maxLength={5000}
                                labelText=""
                                id="inputAdditionalNotes"
                                name="inputAdditionalNotes"
                                cols={250}
                                disabled={this.state.editingDisabled}
                                invalid={false}
                                invalidText="required"
                                light
                                placeholder=""
                                rows={10}
                                value={this.state.audit.additionalNotes || ''}
                                onChange={this.onAdditionalNoteChange}
                              />
                            </FormGroup>
                          </div>

                          <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                            <Button
                              size="default"
                              renderIcon={Save16}
                              kind="primary"
                              onClick={this.updateConsideration}
                              disabled={this.state.editingDisabled}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Tile>
                      <Tile className="bx--tile bx--tile--light">
                        <div className="bx--col-lg-6 bx--col-md-6">
                          <Online>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUpload}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"
                            />
                          </Online>
                          <Offline>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUpload}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"

                            />
                          </Offline>
                        </div>
                      </Tile>
                      <Tile className="bx--tile bx--tile--light">
                        <div className="bx--col-lg-12 bx--col-md-12">
                          <TableContainer className="bx--grid--full-width">
                            <Table>
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader>Name</TableHeader>
                                  <TableHeader>Size</TableHeader>
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.audit.attachments < 1 ? (
                                  <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                                ) : (
                                  this.state.audit.attachments.map((item) => (
                                    <TableRow key={`row_${item.id}`}>
                                      <TableCell key={`cell_1_${item.id}`}>{item.name}</TableCell>
                                      <TableCell key={`cell_2_${item.id}`}>
                                        {sizeFormat(item.size)}
                                      </TableCell>
                                      <TableCell
                                        key={`action-${item.id}`}
                                        className="tableActions align-center"
                                      >
                                        {this.state.downloading === item.id ? (
                                          <div>
                                            <InlineLoading
                                              description=""
                                              iconDescription="downloading.."
                                              status="active"
                                            />
                                          </div>
                                        ) : (
                                          <div>
                                            <Online>
                                              <DownLoadButton
                                                onError={(error) => {
                                                  showNotification.error(
                                                    `${entitiesLabels.ERROR}`,
                                                    getError(
                                                      error,
                                                      entitiesLabels.FileUpload,
                                                      apioperation.GET
                                                    )
                                                  );
                                                }}
                                                onDownLoadStart={() =>
                                                  this.setState({ downloading: item.id })
                                                }
                                                onDownLoadEnd={() =>
                                                  this.setState({ downloading: null })
                                                }
                                                apiUrl={`/audit/${this.state.audit.id}/attachment/${item.fileIdentifier}`}
                                                fileName={item.name}
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                disabled={this.state.editingDisabled}
                                              />
                                              <Button
                                                onClick={() => this.onDeleteAttachment(item.id)}
                                                size="small"
                                                renderIcon={Delete16}
                                                iconDescription="Delete"
                                                kind="ghost"
                                                disabled={this.state.editingDisabled}
                                              />
                                            </Online>
                                            <Offline>
                                              <Button
                                                size="small"
                                                renderIcon={View16}
                                                iconDescription="Download"
                                                kind="ghost"
                                                disabled
                                              />
                                              <Button
                                                onClick={() => this.onDeleteAttachment(item.id)}
                                                size="small"
                                                renderIcon={Delete16}
                                                iconDescription="Delete"
                                                kind="ghost"
                                                disabled
                                              />
                                            </Offline>
                                          </div>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Tile>
                    </div>
                  </Tab>

                  <Tab
                    href="#"
                    label="Personnel"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                    disabled={!this.state.audit.checkList.notificationForm.savedOn}
                  >
                    <div className="some-content">
                      <AuditPersonnel
                        id="PersonnelSection"
                        key={this.state.audit}
                        division={this.state.audit.idDivision}
                        auditors={this.state.audit.auditors}
                        auditees={this.state.audit.auditees}
                        onAuditorAdd={this.onAuditorAdd}
                        onAuditorDelete={this.onAuditorDelete}
                        employees={this.state.employees}
                        onAuditeesAdd={this.onAuditeesAdd}
                        onAuditeesDelete={this.onAuditeesDelete}
                        disabled={this.state.editingDisabled}
                        //userDivision={this.state.userDivision} //B1_Audit_Module_Optimization
                      />
                    </div>
                    <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
                      <Button
                        size="default"
                        renderIcon={Save16}
                        kind="primary"
                        onClick={this.updatePersonnel}
                        disabled={this.state.editingDisabled}
                      >
                        Save
                      </Button>
                    </div>
                  </Tab>
                  <Tab
                    href="#"
                    label="Requirement"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                    disabled={!this.state.audit.checkList.notificationForm.savedOn}
                  >
                    <div className="some-content">
                      <div className="bx--row main-information-itmes">
                        <div className="bx--col-lg-3 bx--col-md-3">
                          <h5>Requirements</h5>
                        </div>
                        <div className="bx--col-lg-9 bx--col-md-9 main-information-button">
                          <Button
                            size="default"
                            renderIcon={Save16}
                            kind="primary"
                            onClick={this.updateCheckList}
                            disabled={this.state.editingDisabled}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                      <Tabs>
                        {this.getTemplate().map((checklistTemp) => (
                          <Tab
                            href="#"
                            label={`${checklistTemp.code} - ${checklistTemp.name}`}
                            className={`${checklistTemp.active ? "bx--tabs__nav-link_is_active" : "bx--tabs__nav-link_is_not_active"} `}
                            onClick={() => {}}
                            onKeyDown={() => {}}
                            role="presentation"
                            selected={false}
                            tabIndex={0}
                            id={checklistTemp.id}
                            key={checklistTemp.id}
                          >
                            <div className="some-content">
                              <Accordion>
                              <div className="bx--row main-information-itmes padding-bottom-low-rem">
                                <div className="padding-left-right-accordion">
                                  <Toggle
                                      toggled={checklistTemp.active}
                                      onToggle={() => this.toggleActiveTemplateQuestions(checklistTemp.id)}
                                      className="toggle-bg-orange mb-20px"
                                      labelText="Template Enabled"
                                      aria-label=""
                                      disabled={this.state.editingDisabled}
                                      id={`toggle-1 - ${checklistTemp.id}`}
                                  />
                                </div>
                                <div className="padding-left-right-accordion" >
                                  <Online>
                                    <DownLoadButton
                                        onError={(error) => {
                                          showNotification.error(getError(error, entitiesLabels.AUDITCHECKLIST_TEMPLATE, apioperation.DOWNLOAD));
                                        }}
                                        size="default"
                                        className="mb-5"
                                        iconDescription="Download Requirement"
                                        title="Download Requirement"
                                        renderIcon={Download16}
                                        apiUrl={`/audit/${this.state.audit.id}/exportrequirement/${checklistTemp.id}`}
                                        fileName={`Audit_${this.state.audit.auditCode}_Requirement_${checklistTemp.code} - ${checklistTemp.name}.xlsx`}
                                        disabled={!checklistTemp.active}
                                        onDownLoadStart={() => {
                                          this.setState({
                                            isLoadingNotificationFile: true,
                                          });
                                        }}
                                        onDownLoadEnd={() => {
                                          this.setState({
                                            isLoadingNotificationFile: false,
                                          });
                                        }}
                                      >
                                      Download Requirement
                                    </DownLoadButton>
                                  </Online>
                                  <Offline>
                                      <DownLoadButton
                                        size="default"
                                        className="mb-5"
                                        iconDescription="Download Requirement"
                                        title="Download Requirement"
                                        renderIcon={Download16}
                                        apiUrl={`/audit/${this.state.audit.id}/exportrequirement/${checklistTemp.id}`}
                                        fileName={`Audit_${this.state.audit.code}_Requirement_${checklistTemp.code} - ${checklistTemp.name}.docx`}
                                        disabled
                                      >
                                        Download Requirement
                                      </DownLoadButton>
                                  </Offline>
                                </div>
                              </div >
                                {this.getSections(checklistTemp.id).map((section) => (
                                  <AccordionItem
                                    className="auditAccordionTitle"
                                    title={`${section.code} - ${section.name}`}
                                    id={section.id}
                                    key={section.id}
                                  >
                                    <div className="bx--row">
                                      <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 main-information-button-detail ">
                                        <Button
                                          disabled={this.state.editingDisabled || !checklistTemp.active}
                                          renderIcon={Add16}
                                          onClick={() => this.showAddRequirement(checklistTemp, section)}
                                        >
                                          Add Requirement
                                        </Button>
                                      </div>
                                    </div>
                                    {this.getQuestionAnswer(section.id).map((qa) => (
                                      <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
                                        <CheckListQuestionAnswer
                                          id={qa.id}
                                          key={qa.id}
                                          questionCode={qa.question.code}
                                          question={qa.question.name}
                                          answer={qa.answer}
                                          note={qa.notes}
                                          disabled={this.state.editingDisabled || !checklistTemp.active}
                                          onAnswerChange={(answer) =>
                                            this.onAnswerChange(qa.id, answer)
                                          }
                                          onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                                          validator={this.validationsAnswer}
                                        />
                                        <div className="bx--row">
                                          <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 main-information-button-content">
                                            <Link
                                              to={{pathname: `/audit/${this.state.audit.id}/${Number(this.state.audit.newCarManagement)}/answer/${qa.id}/car`}}
                                            >
                                              <Button
                                                disabled={this.state.editingDisabled || !checklistTemp.active}
                                                id={`btn${qa.id}`}
                                                key={`btn${qa.id}`}
                                                size="small"
                                                kind="tertiary"
                                                renderIcon={Add16}
                                                onClick={this.updateCheckList}
                                              >
                                                Associate Findings
                                              </Button>
                                              <span className="main-information-span">
                                                {/* RITM0646764: Rinominato CARs in FINDINGs */}
                                                {`FINDINGs: ${
                                                  qa.cars.length > 0
                                                    ? qa.cars.filter((el) => el.enabled).length
                                                    : 0
                                                }`}
                                                {/* RITM0646764: FINE */}
                                              </span>
                                            </Link>
                                          </div>
                                          <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 padding-bottom-2rem requirement-answer-attachment">
                                            <div className="button-items--modal">
                                              {qa.attachments && qa.attachments.length > 0 ? (
                                                <span className="main-information-span ">
                                                  Attachments: {qa.attachments.length}
                                                </span>
                                              ) : (
                                                ''
                                              )}
                                            </div>
                                            <Button
                                              disabled={this.state.editingDisabled || !checklistTemp.active}
                                              kind="primary"
                                              size="small"
                                              renderIcon={Attachment16}
                                              onClick={() => this.showModalAttachment(qa.id)}
                                            >
                                              Attachments
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                    {this.getRequirementAnswer(section.id).map((qa) => (
                                      <div id={`div${qa.id}`} key={`div${qa.id}`} className="requirement-answer-section">
                                        <CheckListQuestionAnswer
                                          id={qa.id}
                                          key={qa.id}
                                          questionCode={qa.requirement.code}
                                          question={qa.requirement.name}
                                          answer={qa.answer}
                                          note={qa.notes}
                                          onAnswerChange={(answer) =>
                                            this.onAnswerChange(qa.id, answer)
                                          }
                                          isCustom
                                          onDeleteCustomRequirement={() =>
                                            this.showDeleteRequirement(qa.requirement.id)
                                          }
                                          onUpdateCustomRequirement={() =>
                                            this.showModifyRequirement(qa.id, qa.requirement)
                                          }
                                          onNoteChange={(note) => this.onNoteChange(qa.id, note)}
                                          disabled={this.state.editingDisabled || !checklistTemp.active}
                                          validator={this.validationsAnswer}
                                        />
                                        <div className="bx--row">
                                          <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-12 main-information-button-content">
                                            <Link
                                              to={{pathname: `/audit/${this.state.audit.id}/${Number(this.state.audit.newCarManagement)}/answer/${qa.id}/car`}}
                                            >
                                              <Button
                                                disabled={this.state.editingDisabled || !checklistTemp.active}
                                                id={`btn${qa.id}`}
                                                key={`btn${qa.id}`}
                                                size="small"
                                                kind="tertiary"
                                                renderIcon={Add16}
                                                onClick={this.updateCheckList}
                                              >
                                                Associate Findings
                                              </Button>
                                              <span className="main-information-span">
                                                {/* RITM0646764: Rinominato CARs in FINDINGs */}
                                                {`FINDINGs: ${
                                                  qa.cars.length > 0
                                                    ? qa.cars.filter((el) => el.enabled).length
                                                    : 0
                                                }`}
                                                {/* RITM0646764: FINE */}
                                              </span>
                                            </Link>
                                          </div>
                                          <div className="bx--col-lg-4 bx--col-md-4 bx--col-sm-12 padding-bottom-2rem requirement-answer-attachment">
                                            <div className="button-items--modal">
                                              {qa.attachments && qa.attachments.length > 0 ? (
                                                <span className="main-information-span ">
                                                  Attachments: {qa.attachments.length}
                                                </span>
                                              ) : (
                                                ''
                                              )}
                                            </div>
                                            <Button
                                              disabled={this.state.editingDisabled || !checklistTemp.active}
                                              kind="primary"
                                              size="small"
                                              renderIcon={Attachment16}
                                              onClick={() => this.showModalAttachment(qa.id)}
                                            >
                                              Attachments
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </AccordionItem>
                                ))}
                              </Accordion>
                            </div>
                          </Tab>
                        ))}
                      </Tabs>
                    </div>
                  </Tab>

                  <Tab
                    href="#"
                    label="FINDINGs List"
                    disabled={!this.state.audit.checkList.notificationForm.savedOn}
                    onClick={() => {
                      this.props.history.push(`/audit/${this.props.match.params.id}/${Number(this.state.audit.newCarManagement)}/car` );
                    }}
                    selected={false}
                    tabIndex={0}
                  />

                  {/* RITM0646764 */}
                  <Tab
                    href="#"
                    label="Report Signed"
                    onClick={() => {}}
                    onKeyDown={() => {}}
                    role="presentation"
                    selected={false}
                    tabIndex={0}
                    disabled={!this.state.audit.checkList.notificationForm.savedOn}
                  >
                    <div className="some-content">        
                    <Tile className="bx--tile bx--tile--light">
                      {this.ifManageReportAttachment(user) && (
                        <div className="bx--col-lg-6 bx--col-md-6">
                          <Online>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUploadReportSigned}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"
                            />
                          </Online>
                          <Offline>
                            <FileUpload
                              Container="saipem"
                              StoragePath="audit"
                              onUpload={this.onUploadReportSigned}
                              disabled={this.state.editingDisabled}
                              title="The mention of names and surnames must be done only if strictly necessary"

                            />
                          </Offline>
                        </div>
                      )}                      
                    </Tile>              
                    <Tile className="bx--tile bx--tile--light">
                        <div className="bx--col-lg-12 bx--col-md-12">
                          <TableContainer className="bx--grid--full-width">
                            <Table>
                              <TableHead className="colorgray">
                                <TableRow>
                                  <TableHeader>Name</TableHeader>
                                  <TableHeader>Size</TableHeader>
                                  <TableHeader className="align-center">Actions</TableHeader>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.audit.reportAttachments < 1 ? (
                                  <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                                ) : (
                                  this.state.audit.reportAttachments?.map((item) => (
                                      <TableRow key={`row_${item.attachment.id}`}>
                                      <TableCell key={`cell_1_${item.attachment.id}`}>{item.attachment.name}</TableCell>
                                      <TableCell key={`cell_2_${item.attachment.id}`}>
                                        {sizeFormat(item.attachment.size)}
                                      </TableCell>
                                      <TableCell
                                        key={`action-${item.attachment.id}`}
                                        className="tableActions align-center"
                                      >
                                        {this.state.downloading === item.attachment.id ? (
                                          <div>
                                            <InlineLoading
                                              description=""
                                              iconDescription="downloading.."
                                              status="active"
                                            />
                                          </div>
                                        ) : (                                          
                                          this.ifManageReportAttachment(user) && (
                                            <div>
                                              <Online>
                                                <DownLoadButton
                                                  onError={(error) => {
                                                    showNotification.error(
                                                      `${entitiesLabels.ERROR}`,
                                                      getError(
                                                        error,
                                                        entitiesLabels.FileUpload,
                                                        apioperation.GET
                                                      )
                                                    );
                                                  }}
                                                  onDownLoadStart={() =>
                                                    this.setState({ downloading: item.attachment.id })
                                                  }
                                                  onDownLoadEnd={() =>
                                                    this.setState({ downloading: null })
                                                  }
                                                  apiUrl={`/audit/${this.state.audit.id}/attachment/${item.attachment.fileIdentifier}`}
                                                  fileName={item.attachment.name}
                                                  size="small"
                                                  renderIcon={View16}
                                                  iconDescription="Download"
                                                  kind="ghost"
                                                  disabled={this.state.editingDisabled}
                                                />
                                                <Button
                                                  onClick={() => this.onDeleteAttachmentReportSigned(item.attachment.id)}
                                                  size="small"
                                                  renderIcon={Delete16}
                                                  iconDescription="Delete"
                                                  kind="ghost"
                                                  disabled={this.state.editingDisabled}
                                                />
                                              </Online>
                                              <Offline>
                                                <Button
                                                  size="small"
                                                  renderIcon={View16}
                                                  iconDescription="Download"
                                                  kind="ghost"
                                                  disabled
                                                />
                                                <Button
                                                  onClick={() => this.onDeleteAttachmentReportSigned(item.attachment.id)}
                                                  size="small"
                                                  renderIcon={Delete16}
                                                  iconDescription="Delete"
                                                  kind="ghost"
                                                  disabled
                                                />
                                              </Offline>
                                            </div>
                                          )                                          
                                        )}
                                      </TableCell>
                                    </TableRow>                                   
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Tile>
                    </div>
                  </Tab>
                </Tabs>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  render() {
    return this.state.audit ? (
      <AppContext.Consumer>
        {({ user }) => (IsEnabled(user, 'Audit') ? this.renderTabs(user) : '')}
      </AppContext.Consumer>
    ) : (
      <></>
    );
  }
}
AuditReport.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
AuditReport.defaultProps = {};
AuditReport.contextType = AppContext;
